import mutations from './eesztResend.mutations'
import actions from './eesztResend.actions'
import getters from './eesztResend.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
